import { ReviewProductsPage } from './review-products.page';
import { httpLoaderFactory } from './../search/search.module';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { SharedModule } from './../shared/shared.module';
import { IonicModule } from '@ionic/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReviewProductsRoutingModule } from './review-products-routing.module';
import { HttpClient } from '@angular/common/http';
import { ProductHeaderCardComponent } from './product-header-card/product-header-card.component';
import { SharedProductModule } from '@app/shared-product/shared-product.module';

@NgModule({
  declarations: [ReviewProductsPage, ProductHeaderCardComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    SharedModule,
    ReviewProductsRoutingModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: httpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    SharedProductModule,
  ],
})
export class ReviewProductsModule {}
